import { createSlice } from '@reduxjs/toolkit';

/**
 * Types slice — global reference data.
 *
 * All types are fetched in a single GET /misc/types call.
 * Data is static and shared across all products (Access + Lockers).
 */

const initialState = {
	// Reference data arrays
	contactTypes: [],
	addressTypes: [],
	adminTypes: [],
	categoryTypes: [],
	fieldTypes: [],
	bookingTypes: [],
	entityTypes: [],
	maintenanceTypes: [],
	roleList: [],
	userTypes: [],
	credentialTypes: [],
	cardTemplatesTypes: [],
	deviceGroupsTypes: [],
	permissionTypes: [],

	// Loading state
	loading: false,
	loadingComplete: false,
	error: null
};

const typesSlice = createSlice({
	name: 'types',
	initialState,
	reducers: {
		// Trigger — saga listens, reducer sets loading
		loadAllTypes(state) {
			state.loading = true;
			state.error = null;
		},

		// Single success action — populates all 13 arrays at once
		loadAllTypesSuccess(state, action) {
			const data = action.payload;
			state.contactTypes = data.contactTypes || [];
			state.addressTypes = data.addressTypes || [];
			state.adminTypes = data.adminTypes || [];
			state.categoryTypes = data.categoryTypes || [];
			state.fieldTypes = data.fieldTypes || [];
			state.bookingTypes = data.bookingTypes || [];
			state.entityTypes = data.entityTypes || [];
			state.maintenanceTypes = data.maintenanceTypes || [];
			state.roleList = data.roleList || [];
			state.userTypes = data.userTypes || [];
			state.credentialTypes = data.credentialTypes || [];
			state.cardTemplatesTypes = data.cardTemplatesTypes || [];
			state.deviceGroupsTypes = data.deviceGroupsTypes || [];
			state.permissionTypes = data.permissionTypes || [];
			state.loading = false;
			state.loadingComplete = true;
		},

		loadAllTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},

		// Exception: IR sync refreshes card templates only (socket-triggered)
		loadCardTemplatesTypes: () => {},
		loadCardTemplatesTypesSuccess(state, action) {
			state.cardTemplatesTypes = action.payload;
		},
		loadCardTemplatesTypesError: () => {}
	}
});

export const typesActions = typesSlice.actions;

export default typesSlice.reducer;
